module.exports = __webpack_public_path__ + "images/1.1788773129009.jpg";